import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class FacebookPage extends ApplicationRecord {
  static jsonapiType = "facebook_pages";

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr() enabled: boolean;

  @Attr() externalId: string;

  @Attr() label: string;

  @Attr() name: string;

  @Attr() notes: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() url: string;

  @Attr() username: string;
}

export default FacebookPage;
